import { heart } from "./shapes/heart";
import { PRODUCTION_FPS } from "../videoProfile";

export const fourierConfig = {
  video: { width: 1080, height: 1920, fps: PRODUCTION_FPS },
  outline: heart,
  sampleCount: 1024,
  trailResolution: 4096,
  circleCounts: [1, 5, 20, 100],
  timing: {
    intro: 2,
    stages: [3, 3, 4, 5],
    outro: 3,
    hold: 0.3,
    crossfade: 0.3,
    focusDelay: 0.35,
    focusDuration: 0.85,
  },
  colors: {
    background: "#080D18",
    circle: "#38CDBD",
    vector: "#6FEAF2",
    trail: "#FF4FA3",
    text: "#F4F8FF",
    muted: "#8B9AAF",
  },
  layout: {
    x: 255,
    targetX: 745,
    y: 1010,
    scale: 200,
    dividerX: 510,
    labelY: 735,
    finish: { x: 540, y: 1010, scale: 355 },
  },
  trailWidth: 5.2,
  showCircles: true,
  minCircleRadius: 0.65,
  text: {
    intro: ["CAN 100 CIRCLES", "DRAW A HEART?"],
    outro: ["THIS IS", "FOURIER TRANSFORM"],
    teaser: "WATCH ROTATION BECOME ART.",
    sourceLabel: "ROTATING CIRCLES",
    targetLabel: "TRACED HEART",
  },
} as const;

export const durationSeconds =
  fourierConfig.timing.intro +
  fourierConfig.timing.stages.reduce((a, b) => a + b, 0) +
  fourierConfig.timing.outro;
